import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProductCodeVm, ProductsService } from 'src/app/api';
import { CombinedStore } from 'src/app/core/combined.store';
import { partners } from '../constants/partner.constant';
import { HOUSING_RESIDENT_PATH, SUBSCRIPTION_PATH } from '../constants/route.constants';
import { PathType } from '../enum/path-type.enum';
import { SharedDataService } from '../services/shared-data.service';

export const partnerGuard: CanActivateFn = (_, state) => {
  const store = inject(CombinedStore);
  const partnerCode = store.context().partnerCode ?? null;
  const sharedDataService = inject(SharedDataService);
  const router = inject(Router);
  const productsService = inject(ProductsService);

  const checkAndRedirect = (): boolean => {
    if (partners.find((x) => x.key === partnerCode)) {
      if (store.forceAddressNavigation()) {
        store.updateForceAddressNavigation(false);
        return true;
      }
      sharedDataService.setGroupStep(0);
      sharedDataService.setStepIndex(4);
      sharedDataService.forceUpdateSubscription();
      router.navigate([SUBSCRIPTION_PATH, HOUSING_RESIDENT_PATH]);
      return false;
    }
    return true;
  };

  return productsService.apiProductsByZipCodeGet(store.postalCode() ?? '').pipe(
    map((productVM: ProductCodeVm) => {
      if (store.path() !== productVM.code) {
        store.updatePath(productVM.code as PathType);
      }
      return checkAndRedirect();
    }),
    catchError(() => {
      console.error('Il y a eu un soucis lors de la récupération du produit.');
      return of(true);
    }),
  );
};
